import { useTranslation } from 'react-i18next';
import { Tricolore } from '@/components/ui/Tricolore';
import { PublicPageTemplate } from '@/components/layout';
import { ButtonLink } from '@/components/ui';

export function NotFound() {
  const { t } = useTranslation();
  return (
    <PublicPageTemplate pageTitle={t('notFound.title')}>
      <section className="mx-auto max-w-screen-xl px-6 py-24 flex flex-col items-center text-center gap-4">
        <span className="font-script text-3xl text-ink-soft">
          {t('notFound.scriptLine')}
        </span>
        <h1 className="font-serif text-7xl md:text-9xl font-light text-ink-2">
          {t('notFound.title')}
        </h1>
        <Tricolore variant="compact" />
        <p className="font-sans text-base text-ink-soft max-w-md mt-2">
          {t('notFound.lede')}
        </p>
        <ButtonLink to="/" className="mt-4" variant="primary">{t('notFound.backHome')}</ButtonLink>
      </section>
    </PublicPageTemplate>
  );
}
